import { lazy, Suspense, useEffect, useState } from 'react';
import './index.css';
import LoadingScreen from './components/LoadingScreen';
import { resolveOfficeHost, type OfficeHost } from './utils/officeHost';

const MarketingApp = lazy(() => import('./MarketingApp'));
const ExcelAddInRoot = lazy(() => import('./ExcelAddInRoot'));

function App() {
  const [officeHost, setOfficeHost] = useState<OfficeHost>('unknown');

  useEffect(() => {
    let cancelled = false;
    void resolveOfficeHost().then((host) => {
      if (!cancelled) setOfficeHost(host);
    });
    return () => {
      cancelled = true;
    };
  }, []);

  if (officeHost === 'unknown') {
    return <LoadingScreen />;
  }

  if (officeHost !== 'excel') {
    return (
      <Suspense fallback={<LoadingScreen />}>
        <MarketingApp />
      </Suspense>
    );
  }

  return (
    <Suspense fallback={<LoadingScreen />}>
      <ExcelAddInRoot />
    </Suspense>
  );
}

export default App;
